module.exports = __webpack_public_path__ + "static/cba-logo-c6139963b00ec905da8a68f2b84132a8.png";